module.exports = __webpack_public_path__ + "img/image4.dd8b0359.png";